import { ClipAvailabilityStatus } from '@goldcast/player-config/src/types/clip-availability';
import createStore from './store';

export const clipAvailabilityStatus = createStore<Record<string, ClipAvailabilityStatus>>({});

export const updateClipAvailabilityStatus = (clipId: string, status: ClipAvailabilityStatus) => {
  // eslint-disable-next-line no-console
  console.log(status);
  clipAvailabilityStatus.update(prevState => ({ ...prevState, [clipId]: status }));
};
